import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import Reveal from '../../components/Reveal';
import usePageTitle from '../../hooks/usePageTitle';

export function JobMeta({ job }) {
  const { t } = useTranslation();
  const jobTypeLabel = t(`jobTypes.${job.jobType}`, { defaultValue: job.jobType });
  const bits = [job.location, jobTypeLabel, job.schedule, job.pay].filter(Boolean);
  return (
    <ul className="job-meta">
      {bits.map((text) => (
        <li key={text}>{text}</li>
      ))}
    </ul>
  );
}

export default function Jobs() {
  const { t } = useTranslation();
  usePageTitle(t('jobs.pageTitle'));
  const [jobs, setJobs] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api.get('/api/site/jobs').then(({ jobs: list }) => setJobs(list)).catch(() => setFailed(true));
  }, []);

  return (
    <>
      <section className="page-hero page-hero-alt">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('jobs.eyebrow')}</span>
            <h1>{t('jobs.title')}</h1>
            <p className="lede">{t('jobs.lede')}</p>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          {failed ? (
            <p className="muted">{t('jobs.loadFailed')}</p>
          ) : !jobs ? (
            <p className="muted">{t('jobs.loading')}</p>
          ) : jobs.length ? (
            <div className="job-list">
              {jobs.map((job, i) => (
                <Reveal key={job.id} className="job-card" delay={i * 60}>
                  <div>
                    <h2><Link to={`/jobs/${job.id}`}>{job.title}</Link></h2>
                    <JobMeta job={job} />
                    <p>{job.description.length > 220 ? `${job.description.slice(0, 220).trim()}…` : job.description}</p>
                  </div>
                  <Link className="btn btn-primary" to={`/jobs/${job.id}`}>{t('jobs.viewApply')}</Link>
                </Reveal>
              ))}
            </div>
          ) : (
            <Reveal className="job-empty">
              <h2>{t('jobs.noJobsTitle')}</h2>
              <p className="muted">{t('jobs.noJobsBody')}</p>
              <Link className="btn btn-primary" to="/register/nanny">{t('jobs.startApplication')}</Link>
            </Reveal>
          )}
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <Reveal className="cta-band">
            <div>
              <h2>{t('jobs.notSeeingTitle')}</h2>
              <p>{t('jobs.notSeeingBody')}</p>
            </div>
            <div className="cta-actions">
              <Link className="btn btn-primary" to="/register/nanny">{t('jobs.becomeNanny')}</Link>
              <Link className="btn btn-outline" to="/contact">{t('jobs.contactUs')}</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
